import repairProduct from '@/api/customer-service/repair-product'

import { baseState, baseMutations } from '@/store/mixins'
import { split, isEmpty } from 'lodash'

export const state = {
  ...baseState,
  formViewDatas: [],
  branch_id: [],
  employee_id: [],
  repair_status_id: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_BRANCH_ID(state, value) {
    state.branch_id = value
  },
  SET_EMPLOYEE_ID(state, value) {
    state.employee_id = value
  },
  SET_REPAIR_STATUS(state, value) {
    state.repair_status_id = value
  },
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewDatas[el] = data[el];
      });
    }
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          branch_id: context.state.branch_id,
          search: context.state.search,
          repaired_by: context.state.employee_id,
          repair_status_id: context.state.repair_status_id,
        }
      },
      attrubutes
    )
    return repairProduct.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return repairProduct.store(data)
  },
  diagnosticRepairProduct(context, { id, data }) {
    return repairProduct.diagnosticRepairProduct(id, data)
  },
  updateRepairStatus(context, { id, data }) {
    return repairProduct.updateRepairStatus(id, data)
  },
  async find(context, id) {
    if (isEmpty(context.state.edit_data)) {
      let response = await repairProduct.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id) {
    return repairProduct.destroy(id)
  },
  async getFormViewModel(context, { params, index }) {
    let response = await repairProduct.formViewModel({ params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  },
}
